import React, { useEffect, useRef, useState } from 'react';
import { Button, ColorPicker, Icon, Loader, Modal, Tab } from '@scuf/common';
import { useAuthService } from '../../../auth/hooks/useAuthService';
import { authService } from '../../../auth/services/authService';
import TreeNode from '../../commonUtils/BMSPPrimereactFork/treenode/TreeNode';
import { SplitPanelUtil } from '../../commonUtils/SplitPanelUtil';
import { IHBSSIRole, OrganisationPanelSummaryView } from './OrganisationPanelSummaryView';
import { OrganisationPanelReuploadView } from './OrganisationPanelReuploadView';
import { ENode, IOrganisationUsers, IPermission } from '../onboardingModels';
import { consumeAPIs, IAPIPackage } from '../../commonUtils/APIContext';
import toasts from '../../commonUtils/toasts';
import useFetch, { IUseFetch } from '../../commonUtils/useFetch';
import i18next from '../../../i18next';
import ForgeOnboardingView from "../OrganisationManagement/ForgeOnboardingView";
import { v4 as uuid4 } from 'uuid';
import { ESitesOnboardingStatus, ESitesSyncStatus, NODES_METADATA_FIELD } from "../../commonUtils/commonEnums";
import SubscribedServicesView from './SubscribedServicesView';
import { findMetaDataValue } from '../onboardingUtils';
import ImageUploadView from './ImageUploadView';
import GatewatAssociationTabContent from './GatewayAssociation/GatewayAssociationTabContent';
import { useFlags } from 'launchdarkly-react-client-sdk';
import warning from '../../../icon/alert-triangle.svg';
import { IOrganisationState } from '../../commonUtils/Redux/Global/globalShared';
import { useSelector } from 'react-redux';

export interface IRootNodeUpdate {
  isRootUpdate ? :boolean,
  updateData: any 
}


interface IOrganisationHierarchySidePanel extends IAPIPackage {
  onClose: () => void;
  onFinish: () => void;
  selectedNode: TreeNode;
  fetchChildrenAndInsert: (rootNodeId: string, parentId: string, isChildrenUpdateNeeded?: boolean,rootNodeUpdate?:IRootNodeUpdate ) => void;
  isCurrencyDefaultValue: boolean;
}

let timer: any = null;

export const OrganisationHierarchySidePanel = (props: IOrganisationHierarchySidePanel) => {
  const { authFetch, baseURL } = useAuthService();
  const environmentVariables = (window as any).ENV;
  const [siteList, setSiteList] = useState<any[]>([]);
  const [fetchSites, setFetchSites] = useState<any[]>([]);
  const [updatedSites, setUpdatedSites] = useState<any[]>([]);
  const [customerId, setCustomerId] = useState('')
  const [checkboxStateAddNewNodes, setCheckboxStateAddNewNodes] = useState<boolean>(true);
  const [checkboxStateUpdateExistingNodes, setCheckboxStateUpdateExistingNodes] = useState<boolean>(true);
  const [checkboxStateDisableOrphanNodes, setCheckboxStateDisableOrphanNodes] = useState<boolean>(true);
  const [uploadDocumentId, setUploadDocumentId] = useState<string>();
  const [isSendingExcelCommit, setIsSendingExcelCommit] = useState<boolean>(false);
  const [hasNodeUpdatePerm, setHasNodeUpdatePerm] = useState(false);
  const [isForgeSiteOnboarding, setIsForgeSiteOnboarding] = useState<boolean>(false);
  const [resetFields, setResetFields] = useState<boolean>(false);
  const [ispollingRequestInProgress, setPollingRequestInProgress] = useState<boolean>(false);
  const [disabled, setDisabled] = useState(false);
  const [btnText, setBtnText] = useState<string>(i18next.t('onboardSelected'));
  const [isUploadActive, setIsUploadActive] = useState<boolean>(false);
  const [isSiteImageUploadActive, setIsSiteImageUploadActive] = useState<boolean>(false);
  const [isSiteDetailTabActive, setIsSiteDetailTabActive] = useState<boolean>(false);
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
  const [timeZone, setTimeZone] = useState(findMetaDataValue(NODES_METADATA_FIELD.TIMEZONE, props.selectedNode.data.metadata));
  const [latitude, setlatitude] = useState(findMetaDataValue(NODES_METADATA_FIELD.LATITUDE, props.selectedNode.data.metadata));
  const [longitude, setlongitude] = useState(findMetaDataValue(NODES_METADATA_FIELD.LONGITUDE, props.selectedNode.data.metadata));
  const [fieldUpdated, setFieldUpdated] = useState([]);
  const [loader, setLoader] = useState(false);
  const [siteProvisioningList, setSiteProvisioningList] = useState<any[]>([]);
  const [latitudeTooltipErrorMsg, setlatitudeTooltipErrorMsg] = useState("");
  const [longitudeTooltipErrorMsg, setlongitudeTooltipErrorMsg] = useState("");
  const [hasNodeMetaDataUpdatePerm, setHasNodeMetaDataUpdatePerm] = useState(false);
  const [HasGatewayUpdatePerm, setHasGatewayUpdatePerm] = useState(false);
  const [imageToUpload, setImageToUpload] = useState<File | null>(null);
  const [isImageUploading, setIsImageUploading] = useState<boolean>(false);
  const [currencyList, setCurrencyList] = useState<{ text: string, value: string }[]>([]);
  const [warningPopUp,setWarningPopUp] = useState<boolean>(false);  
  const [currency, setCurrency] = useState(props.selectedNode.data?.type==ENode.Organisation ?  props.selectedNode.data.currency : findMetaDataValue(NODES_METADATA_FIELD.Currency, props.selectedNode.data.metadata));
 
  const flag = useFlags();
  const [hasPortfolio_OrganizationAccess, setPortfolio_OrganizationAccess]=useState<IHBSSIRole>({
    isHBSOrg :false,
    isPortfolioManager :false,
    isOrganisationManager :false
  });
  
  const isHbsSiOrg=flag?.hbsSiOrg?.some((org: string) => org === props.selectedNode.data.rootNodeId);

  const globalAbortControllerRef = useRef<AbortController>(
    new AbortController()
  );
 const defaultCurrency = 'USD';
    const userProfileDetails = useSelector(
      (state: IOrganisationState) => state.globalShared.userList
    );
    const getActivatedUsers = async (rootNodeId: string, isHbsSiOrg :boolean) => {
      try {    
          const response = await props.authFetch(
            `${props.baseURL}/api/v1/users/orgs/${rootNodeId}`,
            {
              method: 'GET'
            }
          );
          const usersResponse = await response.json();
          const users= usersResponse.resources as IOrganisationUsers[];
          
          const hasRole = users.find(user => user.id === userProfileDetails.id) as IOrganisationUsers;
          if(isHbsSiOrg){
            setPortfolio_OrganizationAccess({
              isHBSOrg: isHbsSiOrg,
              isPortfolioManager:hasRole &&  hasRole.roles.some(role => role.name === "Portfolio Manager"),
              isOrganisationManager: hasRole && hasRole.roles?.some(role => role.name === "Organisation Manager")
            });          
        }
      } catch (error) {
        console.error("Failed to fetch activated users", error);
      }
    };
 
    const cancelExcelUpload = () => {
    if (uploadDocumentId) {
      authFetch(
        `${props.baseURL}/api/v1/organisations/${props.offering}/batch/cancel?offeringId=${props.offering}&documentId=${uploadDocumentId}`,
        {
          method: 'POST'
        }
      );
    }
    setUploadDocumentId(undefined);
    props.onClose();
  };

  const onSaveUploadImage = () => {
    //Api call based on Upload type
    let orgId = props.selectedNode.data.rootNodeId;
    let siteId = props.selectedNode.data.id;
    const apiPath = props.selectedNode.data.type === ENode.Site ? `sites/${siteId}/site-image-commands` : `org-logo-commands`;
    const urlPath = `${props.baseURL}/api/v1/organisations/${orgId}/${apiPath}/${uuid4()}`;

    const data = new FormData();
    imageToUpload ? data.append('image', imageToUpload) : data.append('image', '')

    setIsImageUploading(true);
    authFetch(
        urlPath,
        {
          method: 'PUT',
          body: data
        }
      )
      .then(response => {
        if (response.ok) {
          setImageToUpload(null);
          toasts.success(i18next.t('imageUploadSuccess'));
          props.onFinish();
        } else {
          throw new Error(i18next.t('requestFailed'));
        }
      })
      .catch(e => {
        toasts.error(i18next.t('saveError'));
      })
      .finally(() => {
        setIsImageUploading(false);
      });
  }

  const onImageDragOrDrop = (file: File | undefined) => {
    //call back function based on that set file
    file !== null ? setImageToUpload(file!) : setImageToUpload(null);
  }

  const onCancelUploadImage = (orgId?: string, siteId?: string) => {
    //Api call based on Upload type
    props.onClose();
  }
  const commitExcelUpload = (
    addNewNodes?: boolean,
    updateExistingNodes?: boolean,
    disabledOrphanedNodes?: boolean
  ) => {
    if (uploadDocumentId && !isSendingExcelCommit) {
      const offeringIdAndDocumentIdQueries = `?offeringId=${props.offering}&documentId=${uploadDocumentId}`;

      const additionalReuploadQueries = `${addNewNodes ? '&create=true' : ''}${updateExistingNodes ? '&update=true' : ''
        }${disabledOrphanedNodes ? '&delete=true' : ''}`;

      const combinedQuery = `${offeringIdAndDocumentIdQueries}${additionalReuploadQueries}`;

      setIsSendingExcelCommit(true);
      authFetch(
          `${props.baseURL}/api/v1/organisations/${props.offering}/batch/commit${combinedQuery}`,
          {
            method: 'POST'
          }
        )
        .then(response => {
          if (response.ok) {
            setUploadDocumentId(undefined);
            toasts.success(i18next.t('addOrgSuccess'));
            props.onFinish();
          } else {
            throw new Error(i18next.t('requestFailed'));
          }
        })
        .catch(e => {
          console.log(i18next.t('excelUploadError'));
          toasts.error(i18next.t('saveError'));
        })
        .finally(() => {
          setIsSendingExcelCommit(false);
        });
    }
  };

  const [
    permissions,
    isLoadingPermissions,
    errorPermissions
  ]: IUseFetch<IPermission[]> = useFetch(
    authService.getOrgPermFetchURL(props.selectedNode.data.id),
    props.authFetch
  );

  const [
    Modelpermissions,
    isModelLoadingPermissions,
    errorModelPermissions
  ]: IUseFetch<IPermission[]> = useFetch(
    authService.getSitePermFetchURL(props.selectedNode.data.rootNodeId, props.selectedNode.data.id),
    props.authFetch
  );

  useEffect(() => {
    if (Modelpermissions && authService.hasPermission(Modelpermissions, 'ModelManagement_Configuration_Write')){
      setHasGatewayUpdatePerm(true);
    }else{
      setHasGatewayUpdatePerm(false);
    }
  }, [Modelpermissions])

  useEffect(() => {
    if (permissions && authService.hasPermission(permissions, 'OrgManagement_Node_Update') && props.selectedNode.data.isExportEnabled) {
      setHasNodeUpdatePerm(true);
    } else {
      setHasNodeUpdatePerm(false);
    }
    if (permissions && authService.hasPermission(permissions, 'OrgManagement_Node_Metadata_Update')) {
      if(props.selectedNode.data?.type==ENode.Organisation){
        if(isHbsSiOrg){
         getCurrencyList();
         getActivatedUsers(props.selectedNode.data.rootNodeId,isHbsSiOrg);
        }
      }
        setHasNodeMetaDataUpdatePerm(true)
    } else {
      setHasNodeMetaDataUpdatePerm(false)
    }
  }, [permissions]);

  useEffect(() => {
    if (errorPermissions) {
      toasts.error("Couldn't get permissions");
    }
  }, [errorPermissions]);

  useEffect(() => {
    if (errorModelPermissions) {
      toasts.error("Couldn't get site permissions");
    }
  }, [errorModelPermissions]);

  useEffect(() => {
    if ((props.selectedNode.data.type === ENode.Site || props.selectedNode.data.type === ENode.Organisation) && activeTabIndex === 0) {
      setIsSiteDetailTabActive(true)
    } else {
      setIsSiteDetailTabActive(false);
    }
  }, [activeTabIndex])


  const checkSaveBtn = () => {
    return !uploadDocumentId;
  }

  const checkImageUploaded = () => {
    return !imageToUpload;
  }

  const updateDataFromDetailsTab = () => {
    if (latitude === "") {
      setlongitudeTooltipErrorMsg('');
      setlatitudeTooltipErrorMsg("Empty value not allowed");
    } else if (longitude === "") {
      setlatitudeTooltipErrorMsg('');
      setlongitudeTooltipErrorMsg("Empty value not allowed")
    } else if (parseFloat(latitude) <= -90 || parseFloat(latitude) >= 90) {
      setlongitudeTooltipErrorMsg('');
      setlatitudeTooltipErrorMsg(`${i18next.t('latitude')} ${i18next.t('tooltipCordinateMessage')} -90° (N) and 90° (S)`)
    } else if (parseFloat(longitude) <= -180 || parseFloat(longitude) >= 180) {
      setlatitudeTooltipErrorMsg('');
      setlongitudeTooltipErrorMsg(`${i18next.t('longitude')} ${i18next.t('tooltipCordinateMessage')} -180° (E) and 180° (W)`)
    } else {
      setLoader(true);
      setlatitudeTooltipErrorMsg('');
      setlongitudeTooltipErrorMsg('');
      let isDataUpdateNeeded = false;
      if (fieldUpdated.length !== 0) {      
        let payload: any = [];
       
        fieldUpdated.map((field: string) => {
          let body: any = {};
          switch (field) {
            case 'timeZone':
              body['key'] = NODES_METADATA_FIELD.TIMEZONE;
              body['value'] = timeZone;
              break;
            case 'latitude':
              body['key'] = NODES_METADATA_FIELD.LATITUDE;
              body['value'] = parseFloat(latitude);
              break;
            case 'longitude':
              body['key'] = NODES_METADATA_FIELD.LONGITUDE;
              body['value'] = parseFloat(longitude);
              break;
            case 'currency':
              body['key'] = NODES_METADATA_FIELD.Currency;
              body['value'] = (props.isCurrencyDefaultValue &&  currency.trim() === "") ? defaultCurrency :currency;
              break;
            default:
              break;
          }
          payload.push(body);
        });

          props
            .authFetch(
              `${props.baseURL}/api/v1/metadata/${props.offering}/update-properties/${props.selectedNode.data.rootNodeId}/${props.selectedNode.data.id}`,
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
              }
            )
            .then(response => {
              if (response.ok) {
                isDataUpdateNeeded = true;
                toasts.success(i18next.t('siteUpdateSuccessMessage'));
                if(props.selectedNode.data.type === ENode.Organisation)
                  { 
                    setWarningPopUp(false);
                  }                
              } else {
                throw new Error(i18next.t('siteUpdateErrorMessage'));
              }
            })
            .catch(e => {
              toasts.error(i18next.t('siteUpdateErrorMessage'));
            })
            .finally(() => {
              if (isDataUpdateNeeded) {
                props.fetchChildrenAndInsert(
                  props.selectedNode.data.rootNodeId,
                  props.selectedNode.data.type === ENode.Organisation ? props.selectedNode.data.rootNodeId
                   : props.selectedNode.data.parentId,
                  true,
                  {
                    updateData:payload,
                    isRootUpdate: props.selectedNode.data.type === ENode.Organisation
                  }
                );
              }
              setFieldUpdated([]);
              setLoader(false);
            });
        
      }
    }
  };

  const onTabChange = (activeIndex: number) => {
    setActiveTabIndex(activeIndex);
    if (hasNodeUpdatePerm && props.selectedNode.data.type === ENode.Organisation && activeIndex === 1) {
      setIsUploadActive(true)
    } else {
      setIsUploadActive(false);
    }

    if ((props.selectedNode.data.type === ENode.Site && activeIndex === 2) ||
      (hasNodeUpdatePerm &&
        props.selectedNode.data.type === ENode.Organisation &&
        activeIndex === 3) ||
      (!hasNodeUpdatePerm &&
        props.selectedNode.data.type === ENode.Organisation &&
        activeIndex === 1)
    ) {
      setIsSiteImageUploadActive(true);
    } else {
      setIsSiteImageUploadActive(false);
    }

  }

  const pollOnBoardingStatus = (requestID: string) => {
    let orgId = props.selectedNode.data.rootNodeId;
    setPollingRequestInProgress(true);
    authService.authFetch(`${props.baseURL}/api/v1/forgesync/orgs/${orgId}/requests/${requestID}`).then(response => {
      if (response.ok) {
        response.json().then((responseData: any) => {
          if (responseData.syncStatus === ESitesOnboardingStatus.COMPLETED) {
            resetField();
            formatCompletedOnboarding(responseData.siteSyncStatus);
          } else if (responseData.syncStatus === ESitesOnboardingStatus.INVALID) {
            resetField();
            let onboardItems = siteList.map((item: any) => {
              return {
                ...item,
                checked: false,
                status: i18next.t('onboardingFailed')
              }
            });
            setUpdatedSites(updateOnboardList(onboardItems));
            toasts.dismiss()
            toasts.error(i18next.t('onBoardingFailure'));
          }
        });
      } else {
        resetField();
        let onboardItems = siteList.map((item: any) => {
          return {
            ...item,
            checked: false,
            status: i18next.t('onboardingFailed')
          }
        });
        setUpdatedSites(updateOnboardList(onboardItems));
        toasts.dismiss()
        toasts.error(i18next.t('onBoardingFailure'));
      }
    });
  }

  const resetField = () => {
    // clear Interval
    if (timer !== null) {
      clearInterval(timer);
      timer = null;
    }
    setPollingRequestInProgress(false);
    setIsForgeSiteOnboarding(false);
    setBtnText(i18next.t('reOnboard'))
    setDisabled(true);
  }


  const formatCompletedOnboarding = (data: any) => {
    let failedSiteData: any = [], onboardSiteData: any = [];
    let onboardItems: any = [];
    for (const item of siteList) {
      data.length > 0 && data.filter((sites: any) => {
        if (sites.siteId === item.siteId) {
          if ([ESitesSyncStatus.UNAVAILABLE, ESitesSyncStatus.TRANSACTIONFAILED,
          ESitesSyncStatus.SITEFAILED, ESitesSyncStatus.SYNCFAILED, ESitesSyncStatus.STATUSFAILED].includes(sites.status)) {
            failedSiteData.push(sites.siteId);
            onboardItems.push({
              ...item,
              checked: true,
              status: i18next.t('onboardingFailed')
            })
          }
          else {           
            let sytemGuidList = JSON.parse(sites.message).SystemGuid
            sytemGuidList.forEach((v:string) => {
              authService
              .authFetch(
                `${props.baseURL}/api/GatewayRegistration/Association`,
                {
                  method: 'POST',
                  headers: {

                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    SystemGuid: v,
                    SiteId: item.siteId,
                    OrgId: props.selectedNode.data.rootNodeId,
                    SiteName: item.siteName,
                    IsForgeSite: true
                  })
                }
              )
              .then(response => {
                if (response.ok) {
                  response.json().then((responseData: any) => {
                    let provisioningStatus = responseData.IsAnnotationSuccess &&
                      responseData.IsRetentionSuccess
                      ? 'completed'
                      : 'failed';
                    onboardItems.push({
                      ...item,
                      checked: true,
                      status: i18next.t('onboardedSuccessfully'),
                      siteData: sites,
                      provisioningStatus: provisioningStatus,
                    });
                    setUpdatedSites(updateOnboardList(onboardItems));
                    let tempSiteList = siteProvisioningList;
                    tempSiteList.push({
                      [sites.siteId]: provisioningStatus
                    });
                    setSiteProvisioningList(tempSiteList);
                  });
                } else {
                  onboardItems.push({
                    ...item,
                    checked: true,
                    status: i18next.t('onboardedSuccessfully'),
                    siteData: sites,
                    provisioningStatus: 'failed',
                  });
                  setUpdatedSites(updateOnboardList(onboardItems));
                  let tempSiteList = siteProvisioningList;
                  tempSiteList.push({ [sites.siteId]: 'failed' });
                  setSiteProvisioningList(tempSiteList)
                }
              })
              .catch(error => {
                console.log('errror', error);
                throw new Error(error);
              })
              .finally(() => {
                onboardSiteData.push(sites.siteId);
                setIsForgeSiteOnboarding(false);
                if (failedSiteData.length === 1 && failedSiteData.length === siteList.length) {
                  toasts.dismiss()
                  toasts.error(i18next.t('onBoardingFailure'));
                } else if (failedSiteData.length > 0 && failedSiteData.length < siteList.length) {
                  toasts.dismiss()
                  toasts.error(i18next.t('sitePartialSuccess'))
                } else if (onboardSiteData.length === 1 && onboardSiteData.length === siteList.length) {
                  toasts.dismiss()
                  toasts.success(i18next.t('siteSuccess'))
                } else if (onboardSiteData.length > 1 && onboardSiteData.length === siteList.length) {
                  toasts.dismiss()
                  toasts.success(i18next.t('multiSiteSuccess'))
                }
              })
            })            
          }
        }
      })
    }
  }

  const initiatePolling = (requestID: string) => {
    if (timer !== null) {
      clearInterval(timer);
      timer = null;
    }

    timer = setInterval(() => {
      if (!ispollingRequestInProgress) {
        pollOnBoardingStatus(requestID);
      }
    }, 15000);
  }

  useEffect(() => {
    return () => {
      if (timer !== null) {
        clearInterval(timer);
        timer = null;
      }
    }
  }, [])

  const updateOnboardList = (onboardItems: any) => {
    onboardItems.forEach((dat: any) => {
      const foundIndex = fetchSites.findIndex((ori: any) => ori['siteId'] === dat['siteId']);
      if (foundIndex >= 0) fetchSites.splice(foundIndex, 1, dat);
      else fetchSites.push(dat);
    });
    setUpdatedSites([]);
    return fetchSites;
  }


  const onButtonClick = () => {
    toasts.info(i18next.t('dataloseWarning'), false);
    setIsForgeSiteOnboarding(true);
    setSiteProvisioningList([]);
    let onboardItems: any = [];

    onboardItems = siteList.map((item: any) => {
      return {
        ...item,
        checked: true,
        status: `${i18next.t('onboarding')}`
      }
    });
    setUpdatedSites(updateOnboardList(onboardItems));
    let orgId = props.selectedNode.data.rootNodeId;
    const body = {
      "customerId": customerId,
      "sites": siteList.map((site: any) => ({ ...site, rbmSiteId: site.siteId }))
    }
    authService.authFetch(`${props.baseURL}/api/v1/forgesync/orgs/${orgId}/initiate-forgesync-commands/${uuid4()}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(response => {
        if (response.ok) {
          response.json().then((responseData: any) => {
            initiatePolling(responseData.requestId);
          });
        } else {
          throw new Error(i18next.t('onBoardingFailure'));
        }
      })
      .catch(e => {
        throw new Error(i18next.t('onBoardingFailure'));
      });
  }

  const onboardingRetry = (siteDetail: any) => {
    toasts.info(i18next.t('dataloseWarning'), false);
    setIsForgeSiteOnboarding(true);
    setSiteProvisioningList([]);
    let onboardItems: any = [];

    onboardItems = siteDetail.map((item: any) => {
      return {
        ...item,
        checked: true,
        status: `${i18next.t('onboarding')}`
      }
    });
    setUpdatedSites(updateOnboardList(onboardItems));
    let orgId = props.selectedNode.data.rootNodeId;
    const body = {
      "customerId": customerId,
      "sites": siteDetail.map((site: any) => ({ ...site, rbmSiteId: site.siteId }))
    }
    authService.authFetch(`${props.baseURL}/api/v1/forgesync/orgs/${orgId}/initiate-forgesync-commands/${uuid4()}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(response => {
        if (response.ok) {
          response.json().then((responseData: any) => {
            initiatePolling(responseData.requestId);
          });
        } else {
          throw new Error(i18next.t('onBoardingFailure'));
        }
      })
      .catch(e => {
        throw new Error(i18next.t('onBoardingFailure'));
      });
  }

  const retryHandler = (siteDetails: any) => {
    if (siteDetails.status === i18next.t('onboardingFailed')) {
      let failedOnboardingSiteList = [
        {
          siteId: siteDetails.siteId,
          siteName: siteDetails.siteName,
          status: siteDetails.status
        }
      ];
      onboardingRetry(failedOnboardingSiteList);
    } else {
      let isSelectedFailedProvisionedSitePresent = siteProvisioningList.map(
        (siteInfo: any) => siteInfo[siteDetails.siteId] === 'failed'
      );
      if (
        siteDetails.siteData.status === 'ModelSyncSuccessful' &&
        isSelectedFailedProvisionedSitePresent
      ) {
        setIsForgeSiteOnboarding(true);
        formatCompletedOnboarding([siteDetails.siteData]);

      }
    }


  }
 const getCurrencyList = () => {
  authService.authFetch(`${props.baseURL}/api/dashboard-settings/currencylist`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })
    .then(response => {
      if (response.ok) {
        response.json().then((responseData: any) => {
            const formattedCurrencyList = responseData.map((currency: any) => ({
            text: currency.key,
            value: currency.value,
            }));
            setCurrencyList(formattedCurrencyList);
        });
      } else {
        throw new Error(i18next.t('onBoardingFailure'));
      }
    })
    .catch(e => {
      throw new Error(i18next.t('onBoardingFailure'));
    });
 }
useEffect(() => {
  (props.isCurrencyDefaultValue &&  hasPortfolio_OrganizationAccess.isHBSOrg && (hasPortfolio_OrganizationAccess.isOrganisationManager || hasPortfolio_OrganizationAccess.isPortfolioManager)) ?
    setFieldUpdated([NODES_METADATA_FIELD.Currency.toLowerCase() as never])
    :setFieldUpdated([]);
},[props.isCurrencyDefaultValue])


const renderCurrencyModal = () => {
  return (
    <div style={{padding:'2rem'}}>
      <Modal closeIcon={true} size={'small'} onClose={() => setWarningPopUp(false)} open={warningPopUp}>
        <Modal.Header >
          <div className='left' style={{display: 'flex'}}><img src={warning} alt="warning" />
          <div style={{color:'#ff9847'}}>{i18next.t('Warning')}</div>
          </div>
          
        </Modal.Header>
          <Modal.Content>
          <div>{i18next.t("Changing the currency wont automatically convert the previously entered financial data. You'll need to correct it by raising a ticket with connectedbuildingsupport@honeywell.com.")}</div>
          <div>{i18next.t("Do you still want to save the changes?")}</div>
          </Modal.Content>
          <Modal.Footer>
          <Button type="secondary" size="small"  content="Cancel" onClick={() => setWarningPopUp(false)}/>
            <Button type="primary" size="small"  content="Yes, Save"  onClick={() => updateDataFromDetailsTab()}  loading={loader}/>
          </Modal.Footer>
      </Modal>
      </div>
  );
}

  return (
    <>
     {renderCurrencyModal()}
      <SplitPanelUtil.Panel onOverlayClicked={props.onClose}>
        <SplitPanelUtil.PanelHeader onPanelClose={props.onClose}>
          <SplitPanelUtil.PanelHeaderTitle>
            {props.selectedNode.data.name}
          </SplitPanelUtil.PanelHeaderTitle>
          <SplitPanelUtil.PanelHeaderActionbar>
            {isLoadingPermissions && isModelLoadingPermissions ? (
              <Icon name="refresh" size="small" loading={true} />
            ) : null}
          </SplitPanelUtil.PanelHeaderActionbar>
        </SplitPanelUtil.PanelHeader>
        <SplitPanelUtil.PanelContent>
          <Tab
            defaultActiveIndex={0}
            onTabChange={(activeIndex: number) => onTabChange(activeIndex)}
          >
            <Tab.Pane title={i18next.t('details')}>
              {/* <div className="panel-tab-content"> */}
              <SplitPanelUtil.PanelContentMain>
                <SplitPanelUtil.PanelContentMainSection>
                  {/* {mapSelectedToOrg()} */}
                  {/* {getNodeDetailsPanelUI(selectedNode.data)} */}
                  <OrganisationPanelSummaryView
                    data={props.selectedNode.data}
                    latitude={latitude}
                    setlatitude={setlatitude}
                    longitude={longitude}
                    setlongitude={setlongitude}
                    timeZone={timeZone}
                    setTimeZone={setTimeZone}
                    setFieldUpdated={setFieldUpdated}
                    fieldUpdated={fieldUpdated}
                    latitudeTooltipErrorMsg={latitudeTooltipErrorMsg}
                    longitudeTooltipErrorMsg={longitudeTooltipErrorMsg}
                    hasNodeMetaDataUpdatePerm={hasNodeMetaDataUpdatePerm}
                    currencyList={currencyList}
                    currency={props.isCurrencyDefaultValue && currency.trim() ===''  ? defaultCurrency : currency}
                    setCurrency={setCurrency}
                    hbsSIRole={hasPortfolio_OrganizationAccess}
                  />
                </SplitPanelUtil.PanelContentMainSection>
              </SplitPanelUtil.PanelContentMain>
              {/* </div> */}
            </Tab.Pane>
            {props.selectedNode &&
              props.selectedNode.data &&
              props.selectedNode.data.type === ENode.Site ? (
              <Tab.Pane title={i18next.t('subscribedServices')}>
                <SplitPanelUtil.PanelContentMain>
                  <SplitPanelUtil.PanelContentMainSection>
                    <SubscribedServicesView
                      orgId={props.selectedNode.data.rootNodeId}
                      siteId={props.selectedNode.data.id}
                      name={props.selectedNode.data.name}
                    />
                  </SplitPanelUtil.PanelContentMainSection>
                </SplitPanelUtil.PanelContentMain>
              </Tab.Pane>
            ) : (
              []
            )}
            {hasNodeUpdatePerm && props.selectedNode &&
              props.selectedNode.data &&
              props.selectedNode.data.type === ENode.Site ? (
              <Tab.Pane title={i18next.t('addImage')}>
                <Loader overlayOpacity={0.5} loading={isImageUploading} />
                <SplitPanelUtil.PanelContentMain>
                  <SplitPanelUtil.PanelContentMainSection>
                    <ImageUploadView
                      orgId={props.selectedNode.data.rootNodeId}
                      siteId={props.selectedNode.data.id}
                      name={props.selectedNode.data.name}
                      onImageDragOrDrop={onImageDragOrDrop}
                      title={i18next.t('siteImgTitle')}
                      dropTxt={i18next.t('siteImgDropTxt')}
                      previewTxt={i18next.t('siteImgPreviewTxt')}
                      tooltipTxt={i18next.t('siteTooltipTxt')}
                      imgInfo={i18next.t('siteImgInfoTxt', {
                        width:environmentVariables.SITE_IMG_WIDTH , 
                        height:environmentVariables.SITE_IMG_HEIGHT 
                      })}
                    />
                  </SplitPanelUtil.PanelContentMainSection>
                </SplitPanelUtil.PanelContentMain>
              </Tab.Pane>
            ) : (
              []
            )}
            {hasNodeUpdatePerm &&
              props.selectedNode &&
              props.selectedNode.data.type === ENode.Organisation ? (
              <Tab.Pane title={i18next.t('upload')}>
                <OrganisationPanelReuploadView
                  selectedNodeId={props.selectedNode.data.id}
                  uploadDocumentId={uploadDocumentId}
                  cancelExcelUpload={cancelExcelUpload}
                  commitExcelUpload={commitExcelUpload}
                  isSendingExcelCommit={isSendingExcelCommit}
                  setUploadDocumentId={setUploadDocumentId}
                  checkboxStateAddNewNodes={checkboxStateAddNewNodes}
                  setCheckboxStateAddNewNodes={setCheckboxStateAddNewNodes}
                  checkboxStateUpdateExistingNodes={
                    checkboxStateUpdateExistingNodes
                  }
                  setCheckboxStateUpdateExistingNodes={
                    setCheckboxStateUpdateExistingNodes
                  }
                  checkboxStateDisableOrphanNodes={
                    checkboxStateDisableOrphanNodes
                  }
                  setCheckboxStateDisableOrphanNodes={
                    setCheckboxStateDisableOrphanNodes
                  }
                />
              </Tab.Pane>
            ) : (
              // The reason this needs to exist it because the semantic-ui-react Tab element
              // only checks if its children are tabs or not, doesnt check for null
              // so rendering null is impossible, as it crashes.
              // This gets around that.
              []
            )}
            {hasNodeUpdatePerm &&
              props.selectedNode.data.type === ENode.Organisation && !isHbsSiOrg ? (
              <Tab.Pane title={i18next.t('forgeOnboarding')}>
                <ForgeOnboardingView
                  selectedNode={props.selectedNode}
                  baseURL={props.baseURL}
                  selectedSitesList={(sitesList, fetchSites) => {
                    setSiteList(sitesList);
                    setFetchSites(fetchSites);
                  }}
                  onboardItems={onButtonClick}
                  isForgeSiteOnboarding={isForgeSiteOnboarding}
                  updatedSites={updatedSites}
                  changeBtnText={() => {
                    setUpdatedSites([]);
                    setDisabled(false);
                    setBtnText(i18next.t('onboardSelected'));
                  }}
                  onboardText={btnText}
                  customerID={id => setCustomerId(id)}
                  resetFields={resetFields}
                  retryHandler={(siteDetail: any) => retryHandler(siteDetail)}
                ></ForgeOnboardingView>
              </Tab.Pane>
            ) : (
              // The reason this needs to exist it because the semantic-ui-react Tab element
              // only checks if its children are tabs or not, doesnt check for null
              // so rendering null is impossible, as it crashes.
              // This gets around that.
              []
            )}

            {props.selectedNode.data.type === ENode.Organisation ? (
              <Tab.Pane title={i18next.t('addLogo')} >
                <Loader overlayOpacity={0.5} loading={isImageUploading} />
                <SplitPanelUtil.PanelContentMain>
                  <SplitPanelUtil.PanelContentMainSection>
                    <ImageUploadView
                      isLogoUpload={true}
                      title={i18next.t('orgImgTitle')}
                      dropTxt={i18next.t('orgImgDropTxt')}
                      imgInfo={i18next.t('orgImgInfoTxt', {
                        width:environmentVariables.ORG_LOGO_IMG_WIDTH , 
                        height:environmentVariables.ORG_LOGO_IMG_HEIGHT 
                      })}
                      previewTxt={i18next.t('orgImgPreviewTxt')}
                      tooltipTxt={i18next.t('orgImgTooltipTxt')}
                      onImageDragOrDrop={onImageDragOrDrop}
                    />
                  </SplitPanelUtil.PanelContentMainSection>
                </SplitPanelUtil.PanelContentMain>
              </Tab.Pane>
            ) : ([])}

            {flag["enableDirectChannelInUi"] && props.selectedNode &&
              props.selectedNode.data &&
              props.selectedNode.data.type === ENode.Site ? (
              <Tab.Pane title={i18next.t('gateway')}>
                <GatewatAssociationTabContent selectedNode={props.selectedNode} hasGatewayUpdatePerm={HasGatewayUpdatePerm} enableGatewayTableList={flag["enableGatewayListForDirectChannelInUi"]}/>
              </Tab.Pane>
            ) : (
              []
            )}
          </Tab>
        </SplitPanelUtil.PanelContent>
        {isSiteDetailTabActive && (
          <SplitPanelUtil.PanelFooter>
            <Button type={'secondary'} onClick={props.onClose}>
              {i18next.t('cancel')}
            </Button>
            <Button
              disabled={fieldUpdated.length === 0}
              onClick={() => {
                props.selectedNode.data.type === ENode.Organisation ? 
                fieldUpdated.find(f=> f=== NODES_METADATA_FIELD.Currency.toLowerCase()) ? setWarningPopUp(true) :updateDataFromDetailsTab()
                :  updateDataFromDetailsTab()
                }
              }
              loading={loader}
            >
              {i18next.t('save')}
            </Button>
          </SplitPanelUtil.PanelFooter>
        )}
        {isUploadActive && (
          <SplitPanelUtil.PanelFooter>
            <Button type={'secondary'} onClick={cancelExcelUpload}>
              {i18next.t('cancel')}
            </Button>
            <Button
              disabled={checkSaveBtn()}
              onClick={() =>
                commitExcelUpload(
                  checkboxStateAddNewNodes,
                  checkboxStateUpdateExistingNodes,
                  checkboxStateDisableOrphanNodes
                )
              }
              loading={isSendingExcelCommit}
            >
              {i18next.t('confirm')}
            </Button>
          </SplitPanelUtil.PanelFooter>
        )}
        {isSiteImageUploadActive && (
          <SplitPanelUtil.PanelFooter>
            <Button type={'secondary'} onClick={() => onCancelUploadImage('orgId', 'siteId')}>
              {i18next.t('cancel')}
            </Button>
            <Button
              type="primary"
              disabled={checkImageUploaded()}
              onClick={() =>
                onSaveUploadImage()
              }
              loading={false}
            >
              {i18next.t('Save')}
            </Button>
          </SplitPanelUtil.PanelFooter>
        )}

      </SplitPanelUtil.Panel>
    </>
  );
};

export default consumeAPIs(OrganisationHierarchySidePanel);